import { APIClient } from '@frontend/api-utils';

export class DeviceEnumClient extends APIClient {
    public static readonly endpoint = '/device-api/v1';

    public static async fetchDevicesTypes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/device-types`);
        return this.handleResponse<string[]>(response);
    }

    public static async fetchDevicesBrands(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/device-brands`);
        return this.handleResponse<string[]>(response);
    }
}
